(() => {
  const SEL = {
    card: '.m-product-card',
    link: '.m-product-card__link',            // imagen/enlace clicable de la tarjeta
    qvBtn: '.m-product-quickview-button',     // “ojito” (abre quick-view)
    closeModal: '[data-view="quick-view"] [data-close], .m-modal__close'
  };

  // 1) Oculta el ojito pero lo deja en DOM (para poder clickearlo por JS)
  function hideEye(btn) {
    if (!btn) return;
    btn.setAttribute('aria-hidden', 'true');
    btn.style.opacity = '1';
    btn.style.pointerEvents = 'block';
  }

  // 2) Intenta abrir el quick-view del card
  function openQuickView(card) {
    const btn = card?.querySelector(SEL.qvBtn);
    if (!btn) return false;

    // Algunos temas lo dejan en “ocupado” tras el primer uso
    btn.removeAttribute('disabled');
    btn.classList?.remove('is-busy', 'm:hidden');

    // Dispara varios eventos (distintos temas escuchan diferentes tipos)
    ['click', 'pointerup', 'touchend'].forEach(type => {
      btn.dispatchEvent(new Event(type, { bubbles: true, cancelable: true }));
    });

    return true;
  }

  // 3) Inicializa una tarjeta (oculta el ojo)
  function initCard(card) {
    hideEye(card.querySelector(SEL.qvBtn));
  }

  // 4) Inicial: procesa las tarjetas ya presentes
  document.querySelectorAll(SEL.card).forEach(initCard);

  // 5) Delegación: si clican la imagen/enlace de la tarjeta => abrimos quick-view
  document.addEventListener('click', (ev) => {
    const a = ev.target.closest(SEL.link);
    if (!a) return;

    const card = a.closest(SEL.card);
    if (!card) return;

    // Evita navegar al PDP: queremos el quick-view
    ev.preventDefault();
    ev.stopPropagation();

    initCard(card);                 // nos aseguramos de que el ojito siga oculto
    if (!openQuickView(card)) {
      // fallback por si el tema inicializa listeners asíncronos
      setTimeout(() => openQuickView(card), 0);
    }
  }, true);

  // 6) Si el grid cambia (paginación/filtros/infinite scroll), reoculta y mantiene el comportamiento
  const obs = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes.forEach(n => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches?.(SEL.card)) initCard(n);
        n.querySelectorAll?.(SEL.card).forEach(initCard);
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });

  // 7) Al cerrar el quick-view, limpia estados “ocupado” para que el siguiente abra sin trabas
  document.addEventListener('click', (ev) => {
    if (!ev.target.closest(SEL.closeModal)) return;
    document.querySelectorAll(`${SEL.qvBtn}[disabled], ${SEL.qvBtn}.is-busy`)
      .forEach(b => { b.removeAttribute('disabled'); b.classList.remove('is-busy'); });
  }, true);


function initProductQuickviewBehavior() {
  document.querySelectorAll('.m-product-card').forEach(card => {
    const eyeBtn = card.querySelector('.m-product-quickview-button');
    const productLink = card.querySelector('.m-product-card__link');

    if (eyeBtn && productLink) {
      // Asegurar que el ojito esté visible siempre
      eyeBtn.style.display = 'inline-flex';

      // Evitar abrir enlace normal
      productLink.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        eyeBtn.click();
      });
    }
  });
}

// Inicializa en carga
initProductQuickviewBehavior();

// Re-inicializa si Shopify/Ajax vuelve a renderizar productos
const observer = new MutationObserver(() => {
  initProductQuickviewBehavior();
});
observer.observe(document.body, { childList: true, subtree: true });





})();


